const Alert = ({ type, message }) => {
  if (!message) return null;

  const style = {
    padding: '10px 15px',
    margin: '10px 0',
    borderRadius: '5px',
    fontWeight: 'bold',
    color: type === 'error' ? '#a94442' : '#3c763d',
    backgroundColor: type === 'error' ? '#f2dede' : '#dff0d8',
    border: `1px solid ${type === 'error' ? '#ebccd1' : '#d6e9c6'}`
  };

  return <div style={style}>{message}</div>;
};

export default Alert;